import PropTypes from 'prop-types'

import SingleFieldForm from '../../form/single-field'

const SuggestionCall = ({ form, pageId, submitSuccessCallback, ...attrs }) => {
  return <div
    {...attrs}>
    <SingleFieldForm
      form={form}
      pageId={pageId}
      submitSuccessCallback={submitSuccessCallback} />
  </div>
}

SuggestionCall.propTypes = {
  form: PropTypes.object,
  pageId: PropTypes.number,
  submitSuccessCallback: PropTypes.func
}

export default SuggestionCall
